import React, { PureComponent } from 'react'
import {
    MessageBarType, TextField,
} from '@fluentui/react'
import history from 'helpers/history'
// eslint-disable-next-line import/named
// import { AppProps } from 'app'
import HomeActuality, { ErrorHomeActuality } from 'requests/objects/homeActuality'
import Status from 'types/status'
import InvalidEntityError from 'requests/errors/invalidEntityError'
import Card from 'components/containers/card'
import Loader from 'components/visuals/loader'
import CancelRequestError from 'requests/errors/cancelRequestError'
import NotImplementedError from 'requests/errors/notImplementedError'
import FilteredVirtualCombobox from 'components/inputs/filteredVirtualCombobox'
import { getUpdatedList, isValidDate } from 'helpers/methods/common'
import UnauthorizedError from 'requests/errors/unauthorizedError'
import { Columns } from 'react-bulma-components'
import { NEW_PATH } from 'types/others'
import { tKey, tObj } from 'helpers/methods/translate'
import parseJson from 'helpers/methods/parseJson'
import EProfile from 'types/users/enums/profile'
import DatePicker from 'components/inputs/datePicker'

/** @debug {import('app').AppProps} */

/**
 * @augments {PureComponent<import('app').AppProps>}
 */
export default class IdHomeActualities extends PureComponent {
    constructor(props) {
        super(props)
        const { match } = this.props
        this.state = {
            /** @type {Status} Current status of the component */
            status: Status.IDLE,
            /** @type {boolean} Is in readonly */
            isReadOnly: !!match?.params?.homeActualityId,
            /** @type {HomeActuality} Element find from API */
            item: new HomeActuality(),
            /** @type {HomeActuality} Initial element fond from API. Used to refresh */
            iniItem: new HomeActuality(),
            /** @type {ErrorHomeActuality} Errors */
            errorField: new ErrorHomeActuality(),
        }

        this.submitInput = React.createRef()
    }

    /**
     * @inheritdoc
     */
    componentDidMount() {
        const { setMessageBar } = this.props
        setMessageBar({ isDisplayed: false })

        this.init()
    }

    /**
     * @inheritdoc
     * @param {object} prevProps Previous Props
     */
    componentDidUpdate(prevProps) {
        const {
            match, setCommand, lang, command,
        } = this.props

        if (match?.params?.homeActualityId !== prevProps?.match?.params?.homeActualityId)
            if (!prevProps?.match.path.includes(`/${NEW_PATH}`)) {
                this.init()
            } else {
                setCommand([])
                this.setupBreadcrumb()
                this.setupCommandBar()
                setCommand(this.commandRead)
            }

        if (lang !== prevProps.lang) {
            setCommand([])
            this.setupBreadcrumb()
            this.setupCommandBar()
            setCommand(command.find(x => x.key === 'edit') ? this.commandRead : this.commandEdit)
        }
    }

    /**
     * @inheritdoc
     */
    componentWillUnmount() {
        this.homeActualitiesHandlerRemoveById?.cancel()
        this.homeActualitiesHandlerGetById?.cancel()
        this.homeActualitiesHandlerUpsert?.cancel()
    }

    /**
     * Setup breadcrumb elements
     */
    setupBreadcrumb() {
        const { setBreadcrumb, match } = this.props

        setBreadcrumb([
            { text: this.tKey('homeActualities'), key: 'homeActuality', href: '/home-actualities' },
            {
                text: match?.params?.homeActualityId ? `${this.tKey('homeActuality')} n°${match?.params?.homeActualityId}` : this.tKey('newHomeActuality'),
                key: 'one-homeActuality',
                isCurrentItem: true,
            },
        ])
    }

    /**
     * Setup commandbar elements
     */
    setupCommandBar() {
        const {
            setCommand, match, setModal, homeActualitiesHandler, setMessageBar,
        } = this.props

        /**
         * @type {import('@fluentui/react').ICommandBarItemProps[]} Commanbar items when readonly
         */
        this.commandRead = [
            {
                key: 'edit',
                text: this.tKey('edit'),
                iconProps: { iconName: 'Edit' },
                onClick: () => this.setState({ isReadOnly: false }, () => setCommand(this.commandEdit)),
                disabled: false,
            },
        ]

        /**
         * @type {import('@fluentui/react').ICommandBarItemProps[]} Commanbar items when editing
         */
        this.commandEdit = [
            {
                key: 'cancel',
                text: this.tKey('cancel'),
                iconProps: { iconName: 'Cancel' },
                onClick: () => {
                    const { iniItem } = this.state
                    this.setState(
                        {
                            isReadOnly: true,
                            item: iniItem,
                            status: Status.PENDING,
                            errorField: new ErrorHomeActuality(),
                        },
                        () => this.setState({ status: Status.IDLE }, // Workaround to reset input with "defaultValue"
                            () => setCommand(this.commandRead)),
                    )
                },
                disabled: !match?.params?.homeActualityId,
            },
            {
                key: 'save',
                text: this.tKey('save'),
                iconProps: { iconName: 'Save' },
                onClick: () => {
                    this.submitInput.current.click()
                },
            },
            {
                key: 'delete',
                text: this.tKey('delete'),
                iconProps: { iconName: 'Delete' },
                onClick: () => {
                    setModal({
                        show: true,
                        title: this.tKey('deleteHomeActuality'),
                        subTitle: this.tKey('sureDeleteHomeActuality'),
                        callback: () => {
                            this.setState({ status: Status.PENDING, isReadOnly: true }, async () => {
                                setCommand([])
                                setMessageBar({ isDisplayed: false })
                                try {
                                    this.homeActualitiesHandlerRemoveById = homeActualitiesHandler.removeById(match?.params?.homeActualityId)
                                    await this.homeActualitiesHandlerRemoveById.fetch()
                                    history.push('/home-actualities')
                                    setMessageBar({ // We must set the messagebar after change page, to force re add it
                                        isDisplayed: true,
                                        type: MessageBarType.success,
                                        message: this.tKey('modalDeleteMessage'),
                                    })
                                } catch (error) {
                                    switch (error?.constructor) {
                                        case CancelRequestError:
                                        case UnauthorizedError:
                                        case InvalidEntityError: break
                                        case NotImplementedError:
                                            // eslint-disable-next-line no-console
                                            console.error(error)
                                            break
                                        default:
                                            setCommand(this.commandEdit)
                                            this.setState({ isReadOnly: false, status: Status.REJECTED })
                                            // eslint-disable-next-line no-console
                                            console.error(error)
                                            break
                                    }
                                }
                            })
                        },
                    })
                },
                disabled: !match?.params?.homeActualityId,
            },
        ]
    }

    /**
     * Init Page
     */
    init() {
        const {
            setCommand, match, location, homeActualitiesHandler, setMessageBar,
        } = this.props

        setCommand([])
        setMessageBar({ isDisplayed: false })
        this.setupBreadcrumb()
        this.setupCommandBar()

        // If there is an id in URL, get element by id
        if (match?.params?.homeActualityId)
            this.setState({ status: Status.PENDING }, async () => {
                if (location.state?.homeActuality) // If object came from history push with a create
                    this.setState({
                        item: location.state?.homeActuality,
                        iniItem: location.state?.homeActuality,
                        status: Status.RESOLVED,
                    }, () => {
                        setCommand([])
                        setCommand(this.commandRead)
                    })
                else
                    try {
                        this.homeActualitiesHandlerGetById = homeActualitiesHandler.getById(match?.params?.homeActualityId)
                        const homeActuality = await this.homeActualitiesHandlerGetById.fetch()
                        this.setState({
                            item: homeActuality,
                            iniItem: homeActuality,
                            status: Status.RESOLVED,
                        }, () => {
                            setCommand([])
                            setCommand(this.commandRead)
                        })
                    } catch (error) {
                        switch (error?.constructor) {
                            case CancelRequestError:
                            case UnauthorizedError:
                            case InvalidEntityError: break
                            case NotImplementedError:
                                // eslint-disable-next-line no-console
                                console.error(error)
                                break
                            default:
                                setCommand(this.commandRead)
                                this.setState({ status: Status.REJECTED })
                                // eslint-disable-next-line no-console
                                console.error(error)
                                break
                        }
                    }
            })
        else
            this.setState({ status: Status.PENDING }, () => {
                this.setState({
                    item: new HomeActuality(),
                    iniItem: new HomeActuality(),
                    status: Status.IDLE,
                }, () => {
                    this.setupCommandBar()
                    setCommand(this.commandEdit)
                })
            })
    }

    /**
     * Function called when valide form in submit, in order to save or create new entity
     */
    upsert() {
        const {
            setCommand, homeActualitiesHandler, match, setMessageBar,
        } = this.props
        const { item } = this.state

        this.setState({ status: Status.PENDING, isReadOnly: true }, async () => {
            setCommand([])
            setMessageBar({ isDisplayed: false })
            try {
                this.homeActualitiesHandlerUpsert = homeActualitiesHandler.upsert(item, match?.params?.homeActualityId)
                const homeActuality = await this.homeActualitiesHandlerUpsert.fetch()

                this.setState({
                    item: homeActuality,
                    iniItem: homeActuality,
                    status: Status.RESOLVED,
                    errorField: new ErrorHomeActuality(),
                })
                this.setupCommandBar()
                setCommand(this.commandRead)

                if (!match?.params?.homeActualityId)
                    history.replace(`/home-actualities/${homeActuality.homeActualityId}`)
            } catch (error) {
                this.setState({ status: Status.REJECTED, isReadOnly: false }, () => {
                    switch (error?.constructor) {
                        case CancelRequestError:
                        case UnauthorizedError: break
                        case NotImplementedError:
                            // eslint-disable-next-line no-console
                            console.error(error)
                            break
                        case InvalidEntityError:
                            this.setState({ errorField: /** @type {InvalidEntityError<ErrorHomeActuality>} */(error).errorField })
                            setCommand(this.commandEdit)
                            break
                        default:
                            setCommand(this.commandEdit)
                            // eslint-disable-next-line no-console
                            console.error(error)
                            break
                    }
                })
            }
        })
    }

    /**
     * Render component
     * @returns {JSX.Element} Element
     */
    render() {
        const {
            item, status, isReadOnly, errorField,
        } = this.state
        const { param, me, lang } = this.props

        if (status === Status.PENDING)
            return <Loader />

        return (
            <main>
                <form
                    onSubmit={ev => {
                        ev.preventDefault()
                        this.upsert()
                    }}
                >
                    <Card
                        title={this.tKey('information')}
                        iconName="PageData"
                    >
                        <Columns>
                            <Columns.Column size="half">
                                <TextField
                                    label={this.tKey('actualityDescription')}
                                    placeholder={this.tKey('actualityDescription')}
                                    value={item.title}
                                    styles={{ field: { height: 117 } }}
                                    readOnly={isReadOnly}
                                    borderless={isReadOnly}
                                    onChange={(ev, newVal) => newVal.length <= 255 && this.setState({ item: { ...item, title: newVal } })}
                                    errorMessage={this.tObj(this.parseJson(errorField.title))}
                                    multiline
                                    required={!isReadOnly}
                                />
                            </Columns.Column>
                            <Columns.Column size="half">
                                <Columns>
                                    <Columns.Column size="half">
                                        <DatePicker
                                            date={item.startDate}
                                            label={this.tKey('startDate')}
                                            readOnly={isReadOnly}
                                            borderless={isReadOnly}
                                            onChangeDate={newVal => {
                                                let startDate = new Date(newVal)
                                                if (!this.isValidDate(startDate))
                                                    startDate = null

                                                this.setState({
                                                    item: {
                                                        ...item,
                                                        startDate,
                                                        endDate: null,
                                                    },
                                                })
                                            }}
                                            required={!isReadOnly}
                                            lang={lang}
                                            minDate={new Date()}
                                            errorMessage={!!errorField.startDate[0] && this.tKey('dateMustBeSelected')}
                                        />
                                    </Columns.Column>
                                    <Columns.Column size="half">
                                        <DatePicker
                                            date={item.endDate}
                                            label={this.tKey('endDate')}
                                            readOnly={isReadOnly}
                                            borderless={isReadOnly}
                                            onChangeDate={newVal => this.setState({
                                                item: { ...item, endDate: this.isValidDate(new Date(newVal)) ? new Date(newVal) : null },
                                            })}
                                            required={!isReadOnly}
                                            lang={lang}
                                            minDate={item.startDate}
                                            errorMessage={!!errorField.endDate[0] && this.tKey('dateMustBeSelected')}
                                        />
                                    </Columns.Column>
                                    <Columns.Column size="half">
                                        <FilteredVirtualCombobox
                                            label={this.tKey('status')}
                                            readOnly={isReadOnly}
                                            options={param.homeActualityStatus.map(x => ({ ...x, text: this.tObj(parseJson(x.text)) }))}
                                            selectedKey={item.homeActualityStatusId}
                                            onChange={(_ev, option) => this.setState({ item: { ...item, homeActualityStatusId: option.key } })}
                                            errorMessage={tObj(parseJson(errorField.homeActualityStatusId))}
                                            required={!isReadOnly}
                                        />
                                    </Columns.Column>
                                    {me.profileId === EProfile.SuperAdmin && (
                                        <Columns.Column size="half">
                                            <FilteredVirtualCombobox
                                                label={this.tKey('companies')}
                                                readOnly={isReadOnly}
                                                options={param.companies.map(x => ({ ...x, text: this.tObj(parseJson(x.text)) }))}
                                                selectedKey={item.companyIds}
                                                onChange={(ev, option) => {
                                                    this.setState({
                                                        item: {
                                                            ...item,
                                                            companyIds: this.getUpdatedList(item.companyIds, option),
                                                        },
                                                    })
                                                }}
                                                errorMessage={tObj(parseJson(errorField.companyIds))}
                                                required={!isReadOnly}
                                                multiSelect
                                            />
                                        </Columns.Column>
                                    )}
                                </Columns>
                            </Columns.Column>
                        </Columns>

                    </Card>
                    {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                    <button
                        type="submit"
                        style={{ display: 'none' }}
                        ref={this.submitInput}
                        tabIndex={-1}
                    />
                </form>
            </main>
        )
    }
}

IdHomeActualities.prototype.getUpdatedList = getUpdatedList
IdHomeActualities.prototype.isValidDate = isValidDate
IdHomeActualities.prototype.parseJson = parseJson
IdHomeActualities.prototype.tKey = tKey
IdHomeActualities.prototype.tObj = tObj
